import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2b8c5efe")

_pushScopeId("data-v-2b8c5efe")
const _hoisted_1 = { class: "InvoiceDocumentHeader" }
const _hoisted_2 = { class: "InvoiceDocumentHeader__number" }
const _hoisted_3 = { class: "InvoiceDocumentHeader__title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.number), 1),
    _createVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
  ]))
})